import http from './httpService';

export function getDepartmentsLoggedUser() {
  return http.get('/departments-login-user');
}

export function getAllProcesses() {
  return http.get('/processes');
}

export function getAllSubProcesses(processId) {
  return http.get(`/subprocesses?processId.equals=${processId}`);
}

export function getAllDepartments(size) {
  return http.get(`/departments?page=0&size=${size}`);
}

export function getKeyRisk(id) {
  return http.get(`/key-indicators/${id}`);
}

export function updateKeyRisk(body) {
  return http.put('/key-indicators', body);
}

export function deleteKeyRisk(id) {
  return http.delete(`/key-indicators/${id}`);
}

export function addKeyRisk(body) {
  return http.post(`/key-indicators`, body);
}

export function deleteKeyRiskOccurrence(id) {
  return http.delete(`/key-indicator-occurs/${id}`);
}

export function addKeyRiskOccurrence(body) {
  return http.post(`/key-indicator-occurs`, body);
}

export function editKeyRiskOccurrence(body) {
  return http.put(`/key-indicator-occurs`, body);
}

export function getKeyRiskOccurrence(id) {
  return http.get(`/key-indicator-occurs/${id}`);
}

export function copyAllKeyIndicators() {
  return http.post('key-indicators/copy-all-key-indicators');
}


export function getCountAllDepartments() {
  return http.get('/departments/count');
}
